import type { Routes } from '@angular/router';
import { BellRing, Calendar, CircleHelp, ClipboardPen, DoorOpen, Home, MapPin, Ticket } from 'lucide-angular';
import { AgendaComponent } from '../../features/agenda/agenda.component';
import { AuthCallbackComponent } from '../../features/auth/pages/auth-callback.component';
import { LoginComponent } from '../../features/auth/pages/login.component';
import { HomeComponent } from '../../features/home/home.component';
import { LocationsComponent } from '../../features/locations/locations.component';
import { ChristmasPartyOverviewComponent } from '../../features/overview/christmas-party-overview.component';
import { LearningAtLunchOverviewComponent } from '../../features/overview/learning-at-lunch-overview.component';
import { NewsAtFourEnergyOverviewComponent } from '../../features/overview/news-at-four-energy-overview.component';
import { OtherOverviewComponent } from '../../features/overview/other-overview.component';
import { OverviewComponent } from '../../features/overview/overview.component';
import { QuestionsComponent } from '../../features/questions/questions.component';
import { publicOnlyGuard } from '../auth/guards/public-only.guard';

export const RoutePaths = {
  HOME: 'home',
  LOGIN: 'login',
  AUTH_CALLBACK: 'auth/microsoft/redirect',
  EVENT: 'event',
  EVENT_OVERVIEW: 'overview',
  EVENT_AGENDA: 'agenda',
  EVENT_LOCATIONS: 'locations',
  EVENT_UPDATES: 'updates',
  EVENT_FEEDBACK: 'feedback',
  EVENT_QUESTIONS: 'questions',
} as const;

export const EventRouteTypes = {
  Afterwork: '',
  Offsite: '',
  Other: 'Other',
  Weihnachtsfeier: 'Weihnachtsfeier',
  NewsAtFourEnergy: 'NewsAtFourEnergy',
  LearningAtLunch: 'LearningAtLunch',
};

export const RouteIcons = {
  HOME: DoorOpen,
  EVENT: Ticket,
  EVENT_OVERVIEW: Home,
  EVENT_AGENDA: Calendar,
  EVENT_LOCATIONS: MapPin,
  EVENT_UPDATES: BellRing,
  EVENT_FEEDBACK: ClipboardPen,
  EVENT_QUESTIONS: CircleHelp,
} as const;

export const PUBLIC_ROUTES: Routes = [
  {
    path: RoutePaths.LOGIN,
    component: LoginComponent,
    canActivate: [publicOnlyGuard],
    data: {
      title: 'Login',
      icon: undefined,
      showTitleCard: false,
    },
  },
  {
    path: RoutePaths.AUTH_CALLBACK,
    component: AuthCallbackComponent,
    canActivate: [publicOnlyGuard],
    data: {
      title: 'Authenticating',
      icon: undefined,
      showTitleCard: false,
    },
  },
];

export const HOME_ROUTES: Routes = [
  {
    path: RoutePaths.HOME,
    component: HomeComponent,
    data: {
      title: '',
      icon: RouteIcons.HOME,
      showTitleCard: false,
    },
  },
];

export const EVENT_ROUTES: Routes = [
  {
    path: `${RoutePaths.EVENT}`,
    children: [
      {
        path: '',
        redirectTo: RoutePaths.HOME,
        pathMatch: 'full',
      },
      {
        path: `${RoutePaths.EVENT_OVERVIEW}`,

        children: [
          {
            path: `${EventRouteTypes.LearningAtLunch}/:eventDocumentId`,
            component: LearningAtLunchOverviewComponent,
            data: {
              title: 'Übersicht',
              icon: RouteIcons.EVENT_OVERVIEW,
              showTitleCard: false,
            },
          },
          {
            path: `${EventRouteTypes.NewsAtFourEnergy}/:eventDocumentId`,
            component: NewsAtFourEnergyOverviewComponent,
            data: {
              title: 'Übersicht',
              icon: RouteIcons.EVENT_OVERVIEW,
              showTitleCard: false,
            },
          },
          {
            path: `${EventRouteTypes.Weihnachtsfeier}/:eventDocumentId`,
            component: ChristmasPartyOverviewComponent,
            data: {
              title: 'Übersicht',
              icon: RouteIcons.EVENT_OVERVIEW,
              showTitleCard: false,
            },
          },
          {
            path: `${EventRouteTypes.Other}/:eventDocumentId`,
            component: OtherOverviewComponent,
            data: {
              title: 'Übersicht',
              icon: RouteIcons.EVENT_OVERVIEW,
              showTitleCard: false,
            },
          },
          {
            path: ':eventType/:eventDocumentId',
            component: OverviewComponent,
            data: {
              title: 'Übersicht',
              icon: RouteIcons.EVENT_OVERVIEW,
              showTitleCard: false,
            },
          },
        ],
      },
      {
        path: `${RoutePaths.EVENT_AGENDA}/:eventType/:eventDocumentId`,
        component: AgendaComponent,
        data: {
          title: 'Agenda',
          icon: RouteIcons.EVENT_AGENDA,
          showTitleCard: true,
        },
      },
      {
        path: `${RoutePaths.EVENT_LOCATIONS}/:eventType/:eventDocumentId`,
        component: LocationsComponent,
        data: {
          title: 'Orte',
          showTitleCard: false,
          icon: RouteIcons.EVENT_LOCATIONS,
        },
      },

      {
        path: `${RoutePaths.EVENT_QUESTIONS}/:eventType/:eventDocumentId`,
        component: QuestionsComponent,
        data: {
          title: 'FAQ',
          showTitleCard: true,
          icon: RouteIcons.EVENT_QUESTIONS,
        },
      },
    ],
  },
];
